import { MAX_DATA_SOURCE_PREVIEW_ROWS } from 'src/constants/limits';

export const addLimitToSqlQuery = (rawQuery: string) => {
  // Normalize the query end before appending our LIMIT: a user may terminate
  // their query with a semicolon, so strip a trailing semicolon and any
  // trailing whitespace to avoid producing invalid SQL like
  // `SELECT * FROM t; LIMIT 25` or leaving a stray space before LIMIT.
  const query = rawQuery.replace(/;\s*$/, '').trimEnd();

  const alreadyHasLimitAtEnd = query.match(
    /limit\s+(\d+)(?:\s+offset\s+\d+)?\s*$/i
  );
  if (alreadyHasLimitAtEnd) {
    return {
      limitedQuery: query,
      resultLimit: parseInt(alreadyHasLimitAtEnd[1]),
    };
  }
  return {
    limitedQuery: `${query} LIMIT ${MAX_DATA_SOURCE_PREVIEW_ROWS}`,
    resultLimit: MAX_DATA_SOURCE_PREVIEW_ROWS,
  };
};
